export interface WatchedRepo {
  fullName: string;
  label: string;
  why: string;
  watchingSince: string;
  /** Last known star count, shown only if the live call fails. */
  snapshotStars: number | null;
}

export const watchedRepos: WatchedRepo[] = [
  { fullName: 'openclaw/openclaw', label: 'OpenClaw', why: 'Self-hosted agent runtime at the centre of the 2026 exposure crisis', watchingSince: '2026-02-01', snapshotStars: null },
  { fullName: 'NousResearch/hermes-agent', label: 'Hermes Agent', why: 'Open agent runtime built around Hermes models', watchingSince: '2026-04-15', snapshotStars: null },
  { fullName: 'langchain-ai/langgraph', label: 'LangGraph', why: 'Stateful multi-agent graphs', watchingSince: '2025-06-01', snapshotStars: null },
  { fullName: 'crewAIInc/crewAI', label: 'CrewAI', why: 'Role-based multi-agent crews', watchingSince: '2025-06-01', snapshotStars: null },
  { fullName: 'microsoft/autogen', label: 'AutoGen', why: 'Microsoft’s multi-agent conversation framework', watchingSince: '2025-06-01', snapshotStars: null },
  { fullName: 'langgenius/dify', label: 'Dify', why: 'Visual LLM app and agent builder', watchingSince: '2025-06-01', snapshotStars: null },
  { fullName: 'n8n-io/n8n', label: 'n8n', why: 'Workflow automation with AI agent nodes', watchingSince: '2025-06-01', snapshotStars: null },
  { fullName: 'modelcontextprotocol/servers', label: 'MCP servers', why: 'Reference Model Context Protocol servers', watchingSince: '2025-06-01', snapshotStars: null },
  { fullName: 'a2aproject/A2A', label: 'A2A', why: 'Agent2Agent protocol spec and SDKs', watchingSince: '2025-06-01', snapshotStars: null },
];
